import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventService } from "../../core/services/event.service";
import {ToastrService} from "ngx-toastr";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import {AuthenticationService} from "../../authentication/authentication.service";
import {FacebookDialogComponent} from '../facebook-dialog/facebook-dialog.component';
import {FacebookFundraiserSummaryDialogComponent} from "../../core/components/dialogs/facebook-fundraiser-summary-dialog/facebook-fundraiser-summary-dialog.component";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../../core/services/utils.service';
import { IeModalComponent } from './ie-modal.component';
import {FacebookService} from "../../core/services/facebook.service";
import {FacebookLoginResponse} from "@capacitor-community/facebook-login";
import {
    AppTrackingStatusResponse,
    AppTrackingTransparency,
} from 'capacitor-plugin-app-tracking-transparency';

@Component({
    selector: 'facebook-fundraiser-link',
    templateUrl: './facebook-fundraiser-link.component.html'
})
export class FacebookFundraiserLinkComponent implements OnInit {

    @Input() isFacebookFundraiserPage: boolean;
    @Output() linkClicked: EventEmitter<any> = new EventEmitter();

    constructor(
        public eventService: EventService,
        public modalService: NgbModal,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private hybridToolsService: HybridToolsService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private facebookService: FacebookService,
        private utilsService: UtilsService
    ) {}

    async ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.mobileFacebookFundraiser) {
            this.router.navigate(
                ['.'],
                {
                    relativeTo: this.activatedRoute,
                    queryParams: {},
                    replaceUrl: true
                }
            );

            const profile = await this.facebookService.getProfile();
            this.openFacebookFundraiserSummaryDialog(profile);
        }
    }

    async continueWithFacebook() {
        this.linkClicked.emit();

        if (this.utilsService.isIE()) {
            this.modalService.open(IeModalComponent)
            return;
        }

        //If facebook is invoked asynchronously apple treats it as an unwanted popup. Thanks apple!
        //It seems that chrome may sometimes flag the popups when there is a delay
        if (this.hybridToolsService.isMobileApp()) {

            if (this.hybridToolsService.isIOS()) {
                let response = await AppTrackingTransparency.getStatus();
                console.log(response);

                let mustRequestPermission = false;

                if (response && response.status && response.status != 'authorized') {
                    mustRequestPermission = true;
                    await AppTrackingTransparency.requestPermission();
                    response = await AppTrackingTransparency.getStatus();
                    console.log(response);
                }

                if (response && response.status && response.status == 'authorized') {
                    if (mustRequestPermission) {
                        //this explicitly forces the user to click the close 'x' or to 'Continue with Facebook' so we can handle updating local storage
                        const options: NgbModalOptions = {
                            backdrop: 'static',
                            keyboard: false
                        }

                        const facebookModal = this.modalService.open(FacebookDialogComponent, options);
                        facebookModal.componentInstance.participantId = this.eventService.selectedEvent.participantId;
                    } else {
                        this.continueWithFacebookAsync();
                    }
                } else {
                    this.toastr.error("Please review App Tracking permissions");
                }
            } else {
                this.continueWithFacebookAsync();
            }

        } else {
            this.continueWithFacebookSync();
        }

    }

    private async continueWithFacebookAsync() {

        const result: FacebookLoginResponse = await this.facebookService.getAccessToken();

        // logout will fail on web if you don't have a token
        if (result?.accessToken?.token) {
            //necessary for iOS/Android apps
            await this.facebookService.logout();
        }

        if(await this.facebookService.login()) {
            const profile = await this.facebookService.getProfile();
            this.openFacebookFundraiserSummaryDialog(profile);
        } else {
            this.toastr.error("Error Logging Into Facebook");
        }
    }

    private continueWithFacebookSync() {

        //let's assume/hope that we don't need a conditional logout like we do for the iOS App
        this.facebookService.syncLogin({}, (profile) => {
            if (profile?.accessToken?.token) {
                this.openFacebookFundraiserSummaryDialog(profile);
            } else {
                this.toastr.error("Error Logging Into Facebook");
            }
        });
    }

    private openFacebookFundraiserSummaryDialog(user: any) {
        let dialogCssClass = 'summary-modal-dialog';
        const cssClass = this.eventService.selectedEvent.cssClass;
        if (cssClass === 'program-s2') {
            dialogCssClass += ' s2-summary-modal-dialog';
        }
        const summaryModal = this.modalService.open(FacebookFundraiserSummaryDialogComponent, {
            windowClass: dialogCssClass,
            backdrop: 'static'
        });
        if (!!user) {
            summaryModal.componentInstance.currentFacebookLogin = user.email;
        }
    }
}
